import React, { FunctionComponent } from "react";
import {
  Grid,
  Table,
  IconButton,
  MuiThemeProvider,
} from "@material-ui/core";
import Dialog from "@material-ui/core/Dialog";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import moment from "moment";
import CloseIcon from "@material-ui/icons/Close";
import MUIDataTable from "mui-datatables";
import { useTableStyles } from "../../../useTableStyle";
import { useCreditCustomerStyles } from "../useCreditCustomerStyles";
import { ThemeProvider } from "@mui/material/styles";

const emptyOptions = {
  pagination: false,
  selectableRows: undefined,
  selectableRowsHeader: false,
  print: false,
  search: false,
  download: false,
  filter: false,
  viewColumns: false,
  display: true,
  responsive: undefined,
  fixedHeaderOptions: {
    xAxis: false,
    yAxis: true,
  },

  isRowSelectable: function () {
    return false;
  },
};

const columns = [
  "Customer Name",
  "Reference",
  "Expiry Date",
  "Status"
];

const options = {
  selectableRows: undefined,
  selectableRowsHeader: false,
  rowsPerPage: 10,
  rowsPerPageOptions: [5, 10, 15, 25, 50, 100],
  print: false,
  download: false,
  filter: false,
  viewColumns: false,
  display: true,
  responsive: undefined,
  fixedHeaderOptions: {
    xAxis: false,
    yAxis: true,
  },

  isRowSelectable: function () {
    return false;
  },
};

interface ReferenceList {
  referenceDetails: Array<Object>;
  closeReferenceDialog: () => void;
  referenceeName: string;
}
export const CreditCustomerReferenceList: FunctionComponent<ReferenceList> = ({
  referenceDetails,
  closeReferenceDialog,
  referenceeName,
}) => {
  const classes = useCreditCustomerStyles();
  const getMuiTheme = useTableStyles();
  if (referenceDetails && referenceDetails.length > 0) {
    return (
      <div>
        <Dialog open maxWidth="md" fullWidth={true}>
          <DialogContent>
            <Grid container>
              <Grid item>
                <DialogContentText
                  style={{
                    color: "black",
                    fontWeight: "bold",
                    fontSize: "1.5em",
                  }}
                >
                  Reference List of {referenceeName}
                </DialogContentText>
              </Grid>
              <Grid item>
                <IconButton
                  aria-label="close"
                  className={classes.closeButton}
                  onClick={closeReferenceDialog}
                >
                  <CloseIcon />
                </IconButton>
              </Grid>
            </Grid>
            <Grid item xs={12}>

              <Table>
                <ThemeProvider theme={getMuiTheme}>
                  <MUIDataTable
                    title={"Reference List"}
                    data={referenceDetails.map((data: any) => {
                      return [

                        data.customer_name,
                        data.customer_ref,
                        moment(data.expiry_date).format(
                          "DD/MM/YYYY  h:mm:ss A"
                        ),
                        data.status_description,
                      ];
                    })}
                    columns={columns}
                    options={options}
                  />
                </ThemeProvider>
              </Table>
            </Grid>
          </DialogContent>
        </Dialog>
      </div>
    );
  } else {
    return (
      <div>
        <Table>
          <ThemeProvider theme={getMuiTheme}>
            <MUIDataTable
              title={"Credit Customer List"}
              columns={columns}
              data={[]}
              options={emptyOptions}
            />
          </ThemeProvider>
        </Table>
      </div>
    );
  }
};
